<template>
    <div class="wrapper">
        <Header/>
        <SideNav/>
        <div class="page-wrapper">
            <div class="page-content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../Shared/Header";
import SideNav from "../Shared/Sidenav.vue";

export default {
    components: {Header, SideNav},
    mounted() {
        setTimeout(() => {
            $("#menu").metisMenu()
        }, 500)
    }
}
</script>

<style lang="scss">
.btn-width {
    min-width: 120px;
}

.btn-width-lg {
    min-width: 30%;
}

.min-height {
    min-height: calc(100vh - 140px);
}

.fixed-card-height {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    overflow-x: hidden;
}

.data-loading {
    filter: blur(2px);
}
</style>
